import { render, staticRenderFns } from "./booksaleslinechart.component.vue?vue&type=template&id=8aeae8b6&scoped=true"
import script from "./booksaleslinechart.component.vue?vue&type=script&lang=js"
export * from "./booksaleslinechart.component.vue?vue&type=script&lang=js"
import style0 from "./booksaleslinechart.component.vue?vue&type=style&index=0&id=8aeae8b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aeae8b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
